module.exports = __webpack_public_path__ + "assets/8220f0764297f418f8326c420f5fd536.png";